import { createSlice } from "@reduxjs/toolkit";

export const initialSurveyAppointmentLocalState = {
  survey: {
    surveyorId: "",
    leadId: "",
    customer_name: "",
    surveyType: "",
    remarks: "",
    surveyDate: "",
    startTime: "",
    endTime: "",
    description: "",
  },
};

export const initialSurveyEventLocalState = {
  surveyorId: "",
  assignTo: "",
  eventType: "Personal",
  event: "",
  startDate: "",
  endDate: "",
};

export const surveyDiarySlice = createSlice({
  name: "surveyDiary",
  initialState: {
    newSurveyLocal: initialSurveyAppointmentLocalState,
    newEventLocal: initialSurveyEventLocalState,
    surveyDiaryData: [],
    surveyDiaryWithEventData: [],
    customerSurveyList: [],
    surveyorList: [],
    surveyDiaryDetail: null,
    surveyDiaryEventDetail: null,
    isSurveyDiarySuccess: false,
    isSurveyDiaryUpdateSuccess: false,
    isSurveyEventSuccess: false,
  },

  reducers: {

    getSurveyDiaryWithEventAction: (state, {payload}) => {},
    setSurveyDiaryWithEventAction: (state, { payload }) => {
      state.surveyDiaryWithEventData = payload;
    },

    getSurveyDiaryAction: (state) => {},
    setSurveyDiaryAction: (state, { payload }) => {
      console.log("surveyDiaryData", payload);
      state.surveyDiaryData = payload?.list;
    },

    getSurvoyerListAction: (state) => {},
    setSurvoyerListAction: (state, { payload }) => {
      state.surveyorList = payload;
    },
    getLeadToSurveyAction: (state) => {},
    setLeadToSurveyAction: (state, { payload }) => {
      state.customerSurveyList = payload?.list;
    },

    addSurveyDiaryAction: (state, { payload }) => {},
    setAddSurveyDiaryResponse: (state, { payload }) => {
      state.isSurveyDiarySuccess = payload;
    },

    updateSurveyDiaryAction: (state, { payload }) => {},
    setUpdateSurveyDiaryResponse: (state, { payload }) => {
      state.isSurveyDiaryUpdateSuccess = payload;
    },

    getSingleSurveyAction: (state, { payload }) => {},
    setSingleSurveyAction: (state, { payload }) => {
      state.surveyDiaryDetail = payload;
    },

    setNewSurveyAction: (state, { payload }) => {
      state.newSurveyLocal = {
        ...state.newSurveyLocal,
        ...payload,
      };
    },

    resetNewSurveyAction: (state) => {
      state.newSurveyLocal = initialSurveyAppointmentLocalState;
    },

    addSurveyEventAction: (state, { payload }) => {},
    setAddSurveyEventAction: (state, { payload }) => {
      state.isSurveyEventSuccess = payload;
    },

    updateSurveyEventAction: (state, { payload }) => {},
    setUpdateSurveyEventAction: (state, { payload }) => {
      state.isSurveyEventSuccess = payload;
    },

    updateNewSurveyAction:(state, {payload})=>{},

    getSingleSurveyEventAction: (state, { payload }) => {},
    setSingleSurveyEventAction: (state, { payload }) => {
      state.surveyDiaryEventDetail = payload;
    },

    setNewSurveyEventAction: (state, { payload }) => {
      state.newEventLocal = {
        ...state.newEventLocal,
        ...payload,
      };
    },

    resetNewSurveyEventAction: (state) => {
      state.newEventLocal = initialSurveyEventLocalState;
    },

    deleteSurveyEventAction: (state, { payload }) => {},
    setDeleteSurveyEventAction: (state, { payload }) => {
      state.isSurveyEventSuccess = payload;
    }
  },
});

const {
  getSurveyDiaryWithEventAction,
  setSurveyDiaryWithEventAction,
  getSurveyDiaryAction,
  setSurveyDiaryAction,
  getSurvoyerListAction,
  setSurvoyerListAction,
  getLeadToSurveyAction,
  setLeadToSurveyAction,
  getSingleSurveyAction,
  setSingleSurveyAction,
  addSurveyDiaryAction,
  setNewSurveyAction,
  setAddSurveyDiaryResponse,
  updateSurveyDiaryAction,
  setUpdateSurveyDiaryResponse,
  resetNewSurveyAction,
  addSurveyEventAction,
  setAddSurveyEventAction,
  updateSurveyEventAction,
  setUpdateSurveyEventAction,
  getSingleSurveyEventAction,
  setSingleSurveyEventAction,
  setNewSurveyEventAction,
  resetNewSurveyEventAction,
  deleteSurveyEventAction,
  setDeleteSurveyEventAction,
  updateNewSurveyAction
} = surveyDiarySlice.actions;

export {
  getSurveyDiaryWithEventAction,
  setSurveyDiaryWithEventAction,
  getSurveyDiaryAction,
  setSurveyDiaryAction,
  getSurvoyerListAction,
  setSurvoyerListAction,
  getLeadToSurveyAction,
  getSingleSurveyAction,
  setSingleSurveyAction,
  setLeadToSurveyAction,
  addSurveyDiaryAction,
  setNewSurveyAction,
  resetNewSurveyAction,
  updateSurveyDiaryAction,
  setUpdateSurveyDiaryResponse,
  setAddSurveyDiaryResponse,
  addSurveyEventAction,
  setAddSurveyEventAction,
  updateSurveyEventAction,
  getSingleSurveyEventAction,
  setSingleSurveyEventAction,
  setUpdateSurveyEventAction,
  setNewSurveyEventAction,
  resetNewSurveyEventAction,
  deleteSurveyEventAction,
  setDeleteSurveyEventAction,
  updateNewSurveyAction
};

export default surveyDiarySlice.reducer;
